import React from 'react';
import styled from 'styled-components/macro';
import { loadAnim } from '../../containers/Donation/actions';
import { width } from '../../utils/size';

const Container = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1;
    z-index: 10;

    @media (max-width: 30em) {
        padding: 1.125em 1em;
    }
`;

const AnimationParent = styled.div`
    position: absolute;
    right: -2px;
    left: -2px;
    top: -2px;
    bottom: -2px;
`;

const AnimationWrapper = styled.div`
    width: 100%;
    height: 100%;

    @media (max-width: 30em) {
        width: 480px;
        margin-left: -${(480 - width()) / 2}px;
    }
`;

class DonationSubmitting extends React.Component {
    constructor() {
        super();
        this.animationWrapper = React.createRef();
    }
    componentDidMount = () => {
        this.setContainer(this.animationWrapper.current);
    };

    setContainer = element => {
        if (element) loadAnim(element);
        return;
    };

    render() {
        return (
            <Container>
                <AnimationParent>
                    <AnimationWrapper ref={this.animationWrapper} />
                </AnimationParent>
            </Container>
        );
    }
}

export default DonationSubmitting;
